import type { EnumOption } from "../../core/types";

// State interface for the field options reducer
// eslint-disable-next-line import/no-unused-modules
export interface FieldOptionsState {
  options: EnumOption[];
  isLoading: boolean;
  error: string | null;
}

// Action types for the field options reducer
// eslint-disable-next-line import/no-unused-modules
export type FieldOptionsAction =
  | { type: "START_LOADING" }
  | { type: "SET_OPTIONS"; payload: EnumOption[] }
  | { type: "SET_CACHED_OPTIONS"; payload: EnumOption[] }
  | { type: "SET_ERROR"; payload: string }
  | { type: "RESET" };

// Initial state for the field options reducer
export const initialFieldOptionsState: FieldOptionsState = {
  options: [],
  isLoading: false,
  error: null,
};

/**
 * Reducer for managing field options state transitions.
 * Handles loading, success, error, and cached data states.
 */
export function fieldOptionsReducer(
  state: FieldOptionsState,
  action: FieldOptionsAction
): FieldOptionsState {
  switch (action.type) {
    case "START_LOADING":
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case "SET_OPTIONS":
      return {
        ...state,
        options: action.payload,
        isLoading: false,
        error: null,
      };

    case "SET_ERROR":
      return {
        ...state,
        options: [],
        isLoading: false,
        error: action.payload,
      };

    case "SET_CACHED_OPTIONS":
      return {
        ...state,
        options: action.payload,
        isLoading: false,
        error: null,
      };

    default:
      return state;
  }
}
